import { SERVICES } from 'src/config/constants'
import { Loader } from 'src/utils/loader'

class EventLoader extends Loader {}

export const eventLoader = new EventLoader({
  service: SERVICES.event
})
